import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';  // LoginForm に修正
import TimeClock from './components/TimeClock';
import AttendanceRecord from './components/AttendanceRecord';
import ShiftManager from './components/ShiftManager';
import Navigation from './components/Navigation';
import AdminDashboard from './components/AdminDashboard';
import UserDetail from './components/UserDetail';
import UserCreate from './components/UserCreate';
import SuperAdminDashboard from './components/SuperAdminDashboard';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
      const storedUserInfo = localStorage.getItem('userInfo');
      if (storedUserInfo) {
        setUserInfo(JSON.parse(storedUserInfo));
      }
    }
  }, []);

  // ログアウト処理
  const handleLogout = () => {
    // ローカルストレージからトークンとユーザー情報を削除
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    
    // アプリケーションの状態を更新
    setIsAuthenticated(false);
    setUserInfo(null);
  };

  // 管理者権限チェック
  const AdminRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }
    
    if (!userInfo || (userInfo.role !== 'admin' && userInfo.role !== 'super_admin')) {
      return <Navigate to="/time-clock" />;
    }
    
    return children;
  };

  // スーパー管理者権限チェック
  const SuperAdminRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }
    
    if (!userInfo || userInfo.role !== 'super_admin') {
      return <Navigate to="/admin" />;
    }
    
    return children;
  };

  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        {isAuthenticated && <Navigation userInfo={userInfo} onLogout={handleLogout} />}
        <Routes>
          <Route 
            path="/login" 
            element={
              !isAuthenticated ? (
                <LoginForm setIsAuthenticated={setIsAuthenticated} setUserInfo={setUserInfo} />
              ) : (
                <Navigate to="/time-clock" />
              )
            } 
          />
          <Route 
            path="/time-clock" 
            element={
              isAuthenticated ? (
                <TimeClock userInfo={userInfo} />
              ) : (
                <Navigate to="/login" />
              )
            } 
          />
          <Route 
            path="/attendance" 
            element={
              isAuthenticated ? (
                <AttendanceRecord userInfo={userInfo} />
              ) : (
                <Navigate to="/login" />
              )
            } 
          />
          <Route 
            path="/shift-manager" 
            element={
              isAuthenticated ? (
                <ShiftManager userInfo={userInfo} />
              ) : (
                <Navigate to="/login" />
              )
            } 
          />
          {/* 管理者用ルート */}
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminDashboard userInfo={userInfo} />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/users/:userId" 
            element={
              <AdminRoute>
                <UserDetail userInfo={userInfo} />
              </AdminRoute>
            } 
          />
          <Route 
            path="/admin/users/new" 
            element={
              <SuperAdminRoute>
                <UserCreate userInfo={userInfo} />
              </SuperAdminRoute>
            } 
          />
          {/* スーパー管理者用ルート */}
          <Route 
            path="/super-admin" 
            element={
              <SuperAdminRoute>
                <SuperAdminDashboard userInfo={userInfo} />
              </SuperAdminRoute>
            } 
          />
          <Route path="/" element={<Navigate to="/time-clock" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;